<template>
  <van-popup class="address" v-model="showDetail" round position="bottom">
    <van-area title="地区选择" :area-list="areaList" @confirm="confirmData" @cancel="hide" />
  </van-popup>
</template>

<script>
import { Area } from 'vant'
import areaList from '../area'

export default {
  components: {
    [Area.name]: Area
  },
  data() {
    return {
      areaList,
      showDetail: false
    }
  },
  methods: {
    show() {
      this.showDetail = true
    },
    confirmData(data) {
      console.log('confirmData', data)
      this.$emit('input', data)
      this.$emit('changeSelectAdress', data)
      this.hide()
    },
    hide() {
      this.showDetail = false
    }
  }
}
</script>

<style lang="scss" scoped>
.address {
  /deep/ .van-picker__toolbar {
    border-bottom: 1px solid #f1f1f1;
  }
}
</style>
